import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useShop } from '../context/ShopContext';
import { useBilling } from '../context/BillingContext';

export const useShopLoader = () => {
  const { isAuthenticated, loading: authLoading } = useAuth();
  const { shop, fetchShop, loading: shopLoading, initialized } = useShop();
  const { fetchUserActivePlan } = useBilling();
  const hasAttemptedFetch = useRef(false);

  useEffect(() => {
    if (isAuthenticated && !authLoading && !shop && !shopLoading && !hasAttemptedFetch.current && initialized) {
      hasAttemptedFetch.current = true;
      fetchShop().then(() => {
        fetchUserActivePlan();
      }).catch(error => {
        // Handle shop fetch error silently
      });
    }
  }, [isAuthenticated, authLoading, shop, shopLoading, initialized, fetchShop, fetchUserActivePlan]);

  return {
    shop,
    loading: authLoading || shopLoading,
    hasShop: !!shop
  };
}; 